import { memo } from 'react'
import { Client } from '../../../pure-js/types/GrooverTypes'
import Box from './Box'
import emptyActivity from '/public/emptyActivity.svg'
import emptyStateImage from '/public/emptyStateImage.svg'
import ActivitySuggestionList from './ActivitySuggestionList'
import GrooverText from './GrooverText'
import useAppState from '../hooks/useAppState'
import { getGrooverText } from '../libs/GrooverTextRepository'

interface EmptyActivityProps {
  client?: Client | null
}

const EmptyActivity = ({ client }: EmptyActivityProps) => {
  const { state } = useAppState()
  const language = state.user?.language

  return (
    <Box fullWidth fullHeight align="center" justify="center">
      <img
        src={emptyActivity}
        width={375}
        height={150}
        alt={getGrooverText('userWeb.activityDetail.emptyActivityImageAlt', language)}
      />
      <img
        src={emptyStateImage}
        width={375}
        height={150}
        alt={getGrooverText('userWeb.activityDetail.emptyStateImageAlt', language)}
      />
      <Box top>
        <GrooverText textKey="externalActivityPageEmptyState" language={language} />
      </Box>
      {client && (
        <Box top fullWidth align="center">
          <ActivitySuggestionList client={client} />
        </Box>
      )}
    </Box>
  )
}

export default memo(EmptyActivity)
